import { ArticleHeading4, UIText1 } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';

import * as styles from './styles.css';

interface IKeyValTableProps {
  title?: string | null;
  className?: string;
  table: Array<{ title: React.ReactNode; value: React.ReactNode }>;
}

export const KeyValTable: React.FC<IKeyValTableProps> = ({ title, table, className }) => {
  return (
    <div className={cn(styles['container'], className)}>
      {title && <ArticleHeading4 as="P">{title}</ArticleHeading4>}

      <div className={styles['wrapper']}>
        {table.map(({ title, value }, i) => (
          <React.Fragment key={i}>
            <UIText1 color="text-secondary-default">{title}</UIText1>
            <UIText1>{value}</UIText1>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
